import { Rutas } from '@/constants/rutas';

import CustomImageComponent from './custom/custom-image';
import CustomLink from './custom/custom-link';

const Logo = ({ styles, width, disableClick }) => {
    const size = width ? width * 1.5 : 105;
    return (
        <CustomLink href={Rutas.INICIO}>
            <CustomImageComponent
                className="image-logo__image"
                src={`${process.env.NEXT_PUBLIC_IMAGES}/analiticafantasy.png?width=${size}&height=${size}&version=2`}
                alt="logo"
                width={size}
                height={size}
                priority={true}
                onClick={() => {
                    if (disableClick) {
                        return;
                    }
                }}
                style={styles}
            />
        </CustomLink>
    );
};

export default Logo;
